import script from "./ResumeImportantModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResumeImportantModal.vue?vue&type=script&setup=true&lang=ts"

import "./ResumeImportantModal.vue?vue&type=style&index=0&id=6fbe0c1f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbe0c1f"]])

export default __exports__